import ArticleBannerApis from "./apis/articleBanner";
import ArticleThumbnailApis from "./apis/articleThumbnail";
import ArticleApis from "./apis/articles";
import AuthApis from "./apis/auth";
import BrandsApis from "./apis/brands";
import CategoriesApis from "./apis/categories";
import FileApis from "./apis/file";
import FormsApis from "./apis/forms";
import GalleryApis from "./apis/gallery";
import PlatformsApis from "./apis/platforms";
import ProductsApis from "./apis/products";
import TagsApis from "./apis/tags";
import UserApis from "./apis/user";

const Common = {
    api: {
        articles: ArticleApis,
        articleBanner: ArticleBannerApis,
        articleThumbnail: ArticleThumbnailApis,
        auth: AuthApis,
        categories: CategoriesApis,
        brands: BrandsApis,
        tags: TagsApis,
        file: FileApis,
        forms: FormsApis,
        gallery: GalleryApis,
        platforms: PlatformsApis,
        products: ProductsApis,
        user: UserApis,
    },
};

export default Common;
